import {
  DadosClienteModel,
} from "@/models/solicitacoes";
import { clienteService } from "@/service/ClienteService";
import store from "@/store";
import {
  getModule,
  Module,
  Mutation,
  MutationAction,
  VuexModule,
} from "vuex-module-decorators";

export interface IClienteModule {
  dadosCliente: DadosClienteModel;
}

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "dadosCliente",
})
class ClienteModule extends VuexModule {
  dadosCliente: DadosClienteModel | null = null;

  @Mutation
  SET_DADOS_CLIENTE(payload: DadosClienteModel) {
    this.dadosCliente = payload;
  }

  @MutationAction({ mutate: ["dadosCliente"], rawError: true })
  async obterDadosCliente(idCliente: number) {
    const dadosCliente = await clienteService.obterAssociado(idCliente);
    return { dadosCliente };
  }

}

export const clienteModule: ClienteModule = getModule(ClienteModule);
